import { render, staticRenderFns } from "./RegisterStep2.vue?vue&type=template&id=0fc54387&"
import script from "./RegisterStep2.vue?vue&type=script&lang=js&"
export * from "./RegisterStep2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports